import type {z} from "zod";
import {AddExpedientResponsibleBody} from "@project/sdk/sales/zod";

export const addExpedientResponsibleFormSchema = AddExpedientResponsibleBody.strict();
export type AddExpedientResponsibleFormPayload = z.output<typeof addExpedientResponsibleFormSchema>;
export const draftAddExpedientResponsibleFormSchema = addExpedientResponsibleFormSchema.partial();
export type DraftAddExpedientResponsibleFormPayload = z.output<
  typeof draftAddExpedientResponsibleFormSchema
>;
